/**
 * WeChat Mini Program Navigation Helper
 */

interface NavigateToOptions {
  url: string;
  success?: (res: any) => void;
  fail?: (res: any) => void;
  complete?: (res: any) => void;
}

class WechatNavigation {
  /**
   * Promise version of wx.miniProgram.navigateTo
   */
  static async navigateTo(options: NavigateToOptions): Promise<void> {
    return new Promise((resolve, reject) => {
      const wx = (window as any).wx;

      wx.miniProgram.navigateTo({
        ...options,
        success: (res: any) => {
          options.success?.(res);
          resolve();
        },
        fail: (res: any) => {
          options.fail?.(res);
          reject(res);
        },
        complete: (res: any) => {
          options.complete?.(res);
        },
      });
    });
  }
}

export default WechatNavigation;
